import { createServerFn } from "@tanstack/react-start";

/**
 * Returns the public Sentry config for the browser.
 * The DSN is a publishable identifier — safe to expose to the client.
 * Lives in a server fn so the secret name (SENTRY_DSN, no VITE_ prefix)
 * stays server-side and the value is read from runtime env at request time.
 */
export const getSentryConfig = createServerFn({ method: "GET" }).handler(
  async () => {
    const dsn = process.env.SENTRY_DSN || null;
    const environment =
      process.env.NODE_ENV === "production" ? "production" : "development";
    return { dsn, environment };
  },
);
